<template>
    <header class="topbar">
        <nav class="navbar top-navbar navbar-expand-md navbar-dark">
            <div class="navbar-header" data-logobg="skin1">
                <!-- This is for the sidebar toggle which is visible on mobile only -->
                <a class="nav-toggler waves-effect waves-light d-block d-md-none" href="javascript:void(0)"><i
                        class="ti-menu ti-close"></i></a>
                <!-- ============================================================== -->
                <!-- Logo -->
                <!-- ============================================================== -->
                <a class="navbar-brand" @click="toHome()" href="javascript:void(0)">
                    <!-- Logo icon -->
                    <b class="logo-icon"></b>
                    <!--End Logo icon -->
                    <!-- Logo text -->
                  <span class="logo-text" v-if="currentUser.email === 'user@transitry.com'"><img alt="homepage" class="light-logo"
                                               src="../../assets/images/logo/Transitry_cx.png"></span>
                    <span class="logo-text" v-else><img alt="homepage" class="light-logo"
                                                 src="../../assets/images/logo/Borlaug_CX.png"></span>
                </a>
                <!-- ============================================================== -->
                <!-- End Logo -->
                <!-- ============================================================== -->
                <!-- ============================================================== -->
                <!-- Toggle which is visible on mobile only -->
                <!-- ============================================================== -->
                <a aria-controls="navbarSupportedContent" aria-expanded="false"
                   aria-label="Toggle navigation" class="topbartoggler d-block d-md-none waves-effect waves-light"
                   data-target="#navbarSupportedContent"
                   data-toggle="collapse" href="javascript:void(0)"><i class="ti-more"></i></a>
            </div>
            <div class="navbar-collapse collapse" id="navbarSupportedContent">
                <ul class="navbar-nav float-left mr-auto">
                    <li class="nav-item d-none d-md-block">
                        <a class="nav-link sidebartoggler waves-effect waves-light" data-sidebartype="mini-sidebar"
                           href="javascript:void(0)">
                            <i class="mdi mdi-menu font-24"></i>
                        </a>
                    </li>
                    <li class="nav-item dropdown mega-dropdown">
                        <a aria-expanded="false" aria-haspopup="true"
                           class="nav-link dropdown-toggle waves-effect waves-dark" data-toggle="dropdown" href="">
                            <span class="d-none d-md-block">{{currentOrg.name}} <i class="fa fa-angle-down"></i></span>
                            <span class="d-block d-md-none"><i class="mdi mdi-dialpad font-24"></i></span>
                        </a>
                        <div class="dropdown-menu animated bounceInDown" v-if="currentOrg.type === 'COOP'">
                            <div class="mega-dropdown-menu row">
                                <div class="col-lg-3 col-xlg-2 m-b-30">
                                    <h4 class="m-b-20">{{currentOrg.name}}</h4>
                                    <p>Web : <a href="">{{currentOrg.biz_web}}</a></p>
                                    <p>Phone : {{currentOrg.biz_phone}}</p>
                                    <p>Email : <a href="">{{currentOrg.biz_email}}</a></p>
                                    <p>Marketplace : {{currentOrg.marketplace_name}}</p>
                                </div>
                                <div class="col-lg-3 m-b-30">
                                    <h4 class="m-b-20">MARKETPLACES</h4>
                                    <!--{{marketplaces}}-->
                                    <ul class="list-style-none">
                                        <li :key="index" v-for="(marketplace, index) of marketplaces">
                                            <a href="javascript:void(0)">
                                                <i class="fa fa-check text-success"
                                                   v-if="marketplace && currentOrg.marketplace_id === marketplace.id"></i>
                                                {{marketplace.name}}
                                                <i class="fas fa-exchange-alt"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-lg-3 col-xlg-4 m-b-30">
                                    <h4 class="m-b-20">SUBSCRIPTION PLAN</h4>
                                    <ul class="list-style-none" v-if="subscriptionPlan.length > 0">
                                        <li>
                                            <a href="javascript:void(0)"><i
                                                    class="fa fa-chevron-right text-success"></i>
                                                {{subscriptionPlan[0].plan_name}}</a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)"><i
                                                    class="fa fa-chevron-right text-success"></i>
                                                {{subscriptionPlan[0].current_period_start | epoch}} -
                                                {{subscriptionPlan[0].current_period_end | epoch}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="dropdown-menu animated bounceInDown" v-if="currentOrg.type !== 'COOP'">
                            <div class="mega-dropdown-menu row">
                                <div class="col-lg-3 col-xlg-2 m-b-30">
                                    <h4 class="m-b-20">{{currentOrg.name}}</h4>
                                    <p>Web : <a href="">{{currentOrg.biz_web}}</a></p>
                                    <p>Phone : {{currentOrg.biz_phone}}</p>
                                    <p>Email : <a href="">{{currentOrg.biz_email}}</a></p>
                                    <p v-if="currentUser.app_type === 'ACRECX_MARKETPLACE'">Marketplace :
                                        {{currentOrg.marketplace_name}}</p>
                                    <p v-if="currentUser.app_type === 'ACRECX_EXPRESS'">Market :
                                        {{currentOrg.express_name}}</p>
                                </div>
                                <div class="col-lg-3 m-b-30" v-if="currentUser.app_type === 'ACRECX_MARKETPLACE'">
                                    <h4 class="m-b-20">MARKETPLACES</h4>
                                    <ul class="list-style-none">
                                        <li>
                                            <a href="javascript:void(0)">
                                                <i class="fa fa-check text-success"></i>
                                                {{currentOrg.marketplace_name}}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-lg-3 m-b-30" v-if="currentUser.app_type === 'ACRECX_EXPRESS'">
                                    <h4 class="m-b-20">MARKET</h4>
                                    <ul class="list-style-none">
                                        <li>
                                            <a href="javascript:void(0)">
                                                <i class="fa fa-check text-success"></i>
                                                {{currentOrg.express_name}}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-lg-3 col-xlg-4 m-b-30"
                                     v-if="currentUser.app_type === 'ACRECX_MARKETPLACE'">
                                    <h4 class="m-b-20">MEMBERSHIP PLAN</h4>
                                    <ul class="list-style-none" v-if="membershipPlan.length > 0">
                                        <li>
                                            <a href="javascript:void(0)"><i
                                                    class="fa fa-chevron-right text-success"></i>
                                                {{membershipPlan[0].name}}</a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)"><i
                                                    class="fa fa-chevron-right text-success"></i>
                                                {{membershipPlan[0].schedule | capitalize}} {{membershipPlan[0].fee |
                                                money}}</a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)"><i
                                                    class="fa fa-chevron-right text-success"></i> Member since
                                                {{membershipPlan[0].begin | date}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item dropdown">
                        <a aria-expanded="false" aria-haspopup="true" class="nav-link dropdown-toggle"
                           data-toggle="dropdown" href="#" role="button">
                            <span class="d-none d-md-block">{{ $t('WorkspaceTopbar.MailOptions.Mail')}}&nbsp;<i
                                    class="fa fa-angle-down"></i></span>
                            <span class="d-block d-md-none"><i class="fa fa-plus"></i></span>
                        </a>
                        <div aria-labelledby="navbarDropdown" class="dropdown-menu">
                            <router-link :to="{ name: 'inbox'}" class="dropdown-item">
                                <i class="mdi mdi-inbox"></i><span class="hide-menu"> {{ $t('WorkspaceTopbar.MailOptions.Inbox')}}</span>
                            </router-link>
                            <router-link :to="{ name: 'compose'}" class="dropdown-item">
                                <i class="mdi mdi-pencil"></i><span class="hide-menu"> {{ $t('WorkspaceTopbar.MailOptions.Compose')}}</span>
                            </router-link>
                        </div>
                    </li>
                    <li class="nav-item search-box">
                        <a class="nav-link waves-effect waves-dark" href="javascript:void(0)">
                            <i class="ti-search"></i>
                        </a>
                        <form class="app-search position-absolute">
                            <input class="form-control" placeholder="Search &amp; enter" type="text"> <a
                                class="srh-btn"><i class="ti-close"></i></a>
                        </form>
                    </li>
                </ul>
                <ul class="navbar-nav float-right">
                    <li class="nav-item dropdown">
                        <a aria-expanded="false" aria-haspopup="true" class="nav-link dropdown-toggle"
                           data-toggle="dropdown" href="#" id="navbarDropdown" role="button">
                            <i :class="getFlagIcon(selectedLanguageIndex)" class="flag-icon"></i>
                        </a>
                        <div aria-labelledby="navbarDropdown"
                             class="dropdown-menu dropdown-menu-right  animated bounceInDown">
                            <a @click="changeLocale(index)" class="dropdown-item" href="#"
                               v-for="(language,index) of languages">
                                <i :class="getFlagIcon(index)" class="flag-icon"></i> {{language.title}}
                            </a>
                        </div>
                    </li>
                    <li class="nav-item dropdown">
                        <a @click="getNotifications" aria-expanded="false" aria-haspopup="true"
                           class="nav-link dropdown-toggle waves-effect waves-dark notifications" data-toggle="dropdown"
                           href="">
                            <i class="mdi mdi-bell font-24"></i>
                            <span class="num" v-if="newNotificationCount >0">{{newNotificationCount}}</span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right mailbox animated bounceInDown">
                            <span class="with-arrow"><span class="bg-info"></span></span>
                            <ul class="list-style-none">
                                <li>
                                    <div class="drop-title bg-info text-white">
                                        <h4 class="m-b-0 m-t-5">{{newNotificationCount}} New</h4>
                                        <span class="font-light">Notifications</span>
                                    </div>
                                </li>
                                <li>
                                    <div class="message-center notifications">
                                        <a :class="{'unseen-notification': notification.visibility === 'UNSEEN'}"
                                           @click="toContext(notification.id, notification.visibility, notification.context, notification.context_props)"
                                           class="message-item custom-border-bottom"
                                           href="javascript:void(0)"
                                           v-bind:key="index"
                                           v-for="(notification, index) in notifications"
                                           v-if="notification">
                                            <span class="btn btn-circle btn-success"
                                                  v-if="notification.context === 'trade'">
                                                <i class="fas fa-handshake"></i>
                                            </span>
                                            <span class="btn btn-circle btn-flickr"
                                                  v-if="notification.context === 'purchase'">
                                                <i class="fas fa-cart-arrow-down"></i>
                                            </span>
                                            <span class="btn btn-circle btn-primary"
                                                  v-if="notification.context === 'sale'">
                                                <i class="fas fa-credit-card"></i>
                                            </span>
                                            <span class="btn btn-circle btn-tumblr"
                                                  v-if="notification.context === 'invoice'">
                                                <i class="fas fa-money-bill-alt"></i>
                                            </span>
                                            <span class="btn btn-circle btn-tumblr"
                                                  v-if="notification.context === 'Partner'">
                                                <i class="fas fa-user-plus"></i>
                                            </span>
                                            <span class="mail-contnet">
                                                <h5 class="message-title">{{notification.name}}</h5>
                                                <span class="mail-desc text-black-50">{{notification.desc | truncate(45, '.....')}}</span>
                                                <span class="time text-black-50">{{notification.created_at| timestamp}}</span>
                                            </span>
                                        </a>
                                    </div>
                                </li>
                                <li>
                                    <a class="text-info nav-link custom-border-top" href="javascript:void(0);">
                                        <b @click="allEvents()" class="float-left"><u>View all Events</u></b>
                                        <b @click="seenAllNotification()" class="float-right"
                                           v-if="newNotificationCount >0"><u>Mark all as Seen</u></b>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="nav-item dropdown">
                        <a @click="getMails()" aria-expanded="false" aria-haspopup="true"
                           class="nav-link dropdown-toggle waves-effect waves-dark notifications" data-toggle="dropdown"
                           href="">
                            <i class="mdi mdi-comment-processing font-24"></i>
                            <span class="num" v-if="newMailCount >0">{{newMailCount}}</span>
                        </a>
                        <div aria-labelledby="2"
                             class="dropdown-menu dropdown-menu-right mailbox animated bounceInDown">
                            <span class="with-arrow"><span class="bg-danger"></span></span>
                            <ul class="list-style-none">
                                <li>
                                    <div class="drop-title text-white bg-danger">
                                        <h4 class="m-b-0 m-t-5">{{newMailCount}} New</h4>
                                        <span class="font-light">Messages</span>
                                    </div>
                                </li>
                                <li>
                                    <div class="message-center message-body ps-container ps-theme-default ps-active-y">
                                        <a :class="{'unseen-notification': mail.status === 'UNREAD'}"
                                           @click="readMail(mail.id)"
                                           class="message-item custom-border-bottom"
                                           href="javascript:void(0)"
                                           v-bind:key="index"
                                           v-for="(mail, index) in mails"
                                           v-if="mail">
                                            <span class="user-img">
                                                <blockie :address="mail.sender.email"></blockie>
                                            </span>
                                            <div class="mail-contnet">
                                                <h5 class="message-title">{{mail.sender.fname}}
                                                    {{mail.sender.lname}}</h5>
                                                <span class="mail-desc">{{mail.subject}}</span>
                                                <span class="time">{{mail.created_at | timestamp}}</span></div>
                                        </a>
                                    </div>
                                </li>
                                <li>
                                    <a class="text-info nav-link custom-border-top" href="javascript:void(0);">
                                        <b @click="readAllMail()" class="float-right" v-if="newMailCount >0"><u>Mark all
                                            as Read</u></b>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="nav-item dropdown">
                        <a aria-expanded="false" aria-haspopup="true"
                           class="nav-link dropdown-toggle text-muted waves-effect waves-dark pro-pic"
                           data-toggle="dropdown"
                           href="" id="user-menu">
                            <blockie :address="currentUser.email"></blockie>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right user-dd animated flipInY">
                            <span class="with-arrow"><span class="bg-primary"></span></span>
                            <div class="d-flex no-block align-items-center p-15 bg-secondary text-white m-b-10">
                                <div class="">
                                    <blockie :address="currentUser.email"></blockie>
                                </div>
                                <div class="m-l-10">
                                    <h4 class="m-b-0">{{this.currentUser && this.currentUser.name}}</h4>
                                    <p class=" m-b-0">{{this.currentUser && this.currentUser.orgs[0].name}}</p>
                                </div>
                            </div>
                            <router-link :to="{ name: 'viewprofile'}" class="dropdown-item">
                                <i class="ti-user m-r-5 m-l-5"></i> My Profile
                            </router-link>

                            <router-link :to="{ name: 'changepassword'}" class="dropdown-item" exact>
                                <i class="fa fa-key m-r-5 m-l-5"></i><span class="hide-menu"> Change Password</span>
                            </router-link>
                            <a class="dropdown-item" href="javascript:void(0)"><i class="ti-wallet m-r-5 m-l-5"></i> My
                                Balance</a>
                            <router-link :to="{name: 'inbox'}" class="dropdown-item">
                                <i class="ti-email m-r-5 m-l-5"></i> Inbox
                            </router-link>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="javascript:void(0)"><i class="ti-settings m-r-5 m-l-5"></i>
                                Account Setting</a>
                            <div class="dropdown-divider"></div>
                            <a @click="handleLogout()" class="dropdown-item" href="javascript:void(0)">
                                <i class="fa fa-power-off m-r-5 m-l-5"></i> Logout
                            </a>
                            <div class="dropdown-divider"></div>
                            <div class="p-l-30 p-10">
                                <router-link :to="{name: 'viewprofile'}" class="btn btn-sm btn-success btn-rounded">
                                    View Profile
                                </router-link>
                            </div>
                        </div>
                    </li>

                </ul>
            </div>
        </nav>
    </header>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "./common/Blockie";
    import i18n from '../../plugins/i18n';
    import _ from 'lodash';
    import io from 'socket.io-client';

    export default {
        name: "WorkspaceTopbar",
        components: {Blockie},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                socket: null,
                plan: [],
                marketplaces: [],
                subscriptionPlan: [],
                membershipPlan: [],
                languages: [
                    {flag: 'us', language: 'en', title: 'English'},
                    {flag: 'in', language: 'hi', title: 'हिंदी'},
                    {flag: 'fr', language: 'fr', title: 'français'},
                    {flag: 'es', language: 'es', title: 'Español'},
                    {flag: 'de', language: 'de', title: 'Deutsche'}
                ],
                selectedLanguageIndex: 0,
                notifications: [],
                newNotificationCount: 0,
                mails: [],
                newMailCount: 0
            }
        },
        mounted() {
            this.socket = io(process.env.VUE_APP_API_URL, {query: `userid=${this.currentUser.id}`});
            this.init();
        },
        methods: {
            async init() {
                this.checkDefaultLocale();
                if (this.currentOrg.type === 'COOP') {
                    await this.getMarketplaces();
                    await this.getSubscriptionPlan();
                } else {
                    await this.getMembershipPlan();
                }
                await this.getNotifications();
                await this.getNotificationsBySocket();
                await this.getMails();
                await this.getMailsBySocket();
            },
            checkDefaultLocale() {
                this.languages.every((language, index) => {
                    if (language.language === i18n.locale) {
                        this.selectedLanguageIndex = index;
                        return false;
                    } else {
                        return true;
                    }
                })
            },
            async handleLogout() {
                if (this.currentUser.app_type === 'ACRECX_MARKETPLACE') {
                    await this.archivedAllNotification();
                    await this.commitAllMail();
                }
                this.$store.commit("LOGOUT");
                this.$router.replace("/auth/login");
            },
            isAdmin() {
                return this.currentOrg && this.currentOrg.role === 'ORG_ADMIN';
            },
            async getMarketplaces() {
                try {
                    let response = await this.$http.get(`/org/${this.currentOrg.id}/marketplaces`);
                    this.marketplaces = response.data;
                } catch (e) {
                    console.log(e);
                }
            },
            async getSubscriptionPlan() {
                try {
                    let response = await this.$http.get(`/org/${this.currentOrg.id}/subscriptions`);
                    let plans = response.data;
                    this.subscriptionPlan = _.filter(plans, _.matches({status: 'active'}));
                    // console.log(this.subscriptionPlan)
                } catch (e) {
                    console.log(e);
                }
            },
            async getMembershipPlan() {
                try {
                    let response = await this.$http.get(`/org/${this.currentOrg.id}/membership`);
                    let plans = response.data;
                    this.membershipPlan = _.filter(plans, _.matches({status: 'ACTIVE'}))
                } catch (e) {
                    console.log(e);
                }
            },
            changeLocale(index) {
                i18n.locale = this.languages[index].language;
                this.selectedLanguageIndex = index;
                this.selectedLanguageIndex = index;
            },
            getFlagIcon(index) {
                return 'flag-icon-' + this.languages[index].flag;
            },
            async getNotifications() {
                try {
                    let reply = await this.$http.get(`/notifications`);
                    this.notifications = reply.data.events;
                    this.newNotificationCount = reply.data.newCount;

                } catch (e) {
                    console.log(e);
                }
            },
            async getNotificationsBySocket() {
                let self = this;
                if (this.currentUser.app_type === 'ACRECX_MARKETPLACE') {
                    this.socket.on('getLatestNotifications', (data) => {
                        if (self.currentUser.id === data.counterpartyid) {
                            self.notifications = data.events;
                            self.newNotificationCount = data.newCount;
                        }
                    })
                }
            },
            toContext(eventid, visibility, context, context_props) {
                switch (context) {
                    case 'trade':
                        this.$router.push({name: "viewtrade", params: {tradeid: context_props.tradeid}});
                        this.$root.$emit('refreshTrade');
                        this.updateEvent(eventid, visibility);
                        break;
                    case 'purchase':
                        this.$router.push({name: "viewpo", params: {poid: context_props.purchaseid}});
                        this.$root.$emit('refreshPo');
                        this.updateEvent(eventid, visibility);
                        break;
                    case 'sale':
                        this.$router.push({name: "viewsale", params: {saleid: context_props.saleid}});
                        this.$root.$emit('refreshSo');
                        this.updateEvent(eventid, visibility);
                        break;
                    case 'invoice':
                        this.$router.push({name: "viewinvoice", params: {invoiceid: context_props.invoiceid}});
                        this.$root.$emit('refreshInvoice');
                        this.updateEvent(eventid, visibility);
                        break;
                    case 'Partner':
                        if (context_props.marketplace_id) {
                            this.$router.push({name: "alloffers"});
                        } else if (context_props.member_id) {
                            this.$router.push({
                                name: "partner-invitation",
                                params: {memberid: context_props.member_id}
                            });
                        }
                        this.updateEvent(eventid, visibility);
                        break;

                }
            },
            async updateEvent(eventid, visibility) {
                if (visibility === 'UNSEEN') {
                    await this.$http.post(`/notifications/${eventid}/seen`);
                }
                await this.getNotifications();
            },
            async seenAllNotification() {
                if (this.newNotificationCount > 0) {
                    await this.$http.post(`/notifications/seen`);
                }
                await this.getNotifications();
            },
            async archivedAllNotification() {
                await this.$http.post(`/notifications/archived`);
            },
            allEvents() {
                this.$router.push({name: 'events'});
                this.$root.$emit('refreshEvents');
            },
            async getMails() {
                try {
                    let reply = await this.$http.get(`mailbox/mailsToNotify`);
                    this.mails = reply.data.mails;
                    this.newMailCount = reply.data.newCount;

                } catch (e) {
                    console.log(e);
                }
            },
            async getMailsBySocket() {
                if (this.currentUser.app_type === 'ACRECX_MARKETPLACE') {
                    this.socket.on('getLatestMails', (data) => {
                        if (this.currentUser.id === data.senderid) {
                            this.mails = data.mails;
                            this.newMailCount = data.newCount;
                        }
                    })
                }
            },
            async readMail(mailid) {
                try {
                    await this.$http.post(`mailbox/${mailid}/read`);
                    await this.getMails();
                    this.$router.push({name: "mail", params: {mailid: mailid}});
                } catch (e) {
                    console.log(e);
                }
            },
            async readAllMail() {
                if (this.newMailCount > 0) {
                    await this.$http.post(`/mailbox/read`);
                }
                await this.getMails();
            },
            async commitAllMail() {
                try {
                    await this.$http.post(`mailbox/commit`);
                } catch (e) {
                    console.log(e);
                }
            },
            toHome(){
                this.$router.push({name: 'dashboard'})
            }
        }
    }
</script>

<style scoped>
    .unseen-notification {
        background-color: #edf2fa;
    }

    .unseen-notification:hover {
        background: #e9ebee !important;
    }

    .custom-border-bottom {
        border-bottom-width: 2px !important;
        border-bottom-style: inset !important;
        border-bottom-color: rgb(226, 226, 213) !important;
    }

    .custom-border-top {
        border-top-width: 1px !important;
        border-top-style: solid !important;
        border-top-color: #cad2e8 !important;
    }

    .notifications .num {
        position: absolute;
        top: 7px;
        left: 30px;
        height: 20px;
        border-radius: 2px;
        background: #ff2c74;
        color: #fff;
        line-height: 20px;
        font-family: sans-serif;
        text-align: center;
        padding: 0px 4px;
    }

    .custom-express {
        font-size: 11px;
        position: absolute;
        top: 16px;
        left: 108px;
    }

    .navbar-dark .navbar-nav .nav-link {
        color: #343a40 !important;
    }

    .topbar {
        box-shadow: 1px 5px 7px rgb(0 0 0 / 5%) !important;
    }

</style>
